import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import AgreementRepository from '@/repositories/agreementRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

// Utis
import utils from '@/commonProject/helpers/utils';

export const useAgreementDetailStore = defineStore({
    id: 'agreementDetail',
    state: () => ({
        RegulationDt: '',
        RegulationNm: '',
        RegulationHistPk: '',
        RegulationContent: '',
    }),
    getters: {},
    actions: {
        reset() {
            this.RegulationDt = '';
            this.RegulationNm = '';
            this.RegulationHistPk = '';
            this.RegulationContent = '';
        },
        /**
         * 規定詳細取得APIをコールする。
         * @param {*} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getAgreementDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const agreementRepository = new AgreementRepository();
            try {
                // 規定詳細取得APIをコールする。
                const response = await agreementRepository.getAgreementDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }

                // APIから取得した情報を加工する。
                // 日時
                this.RegulationDt = utils.isNullEmpty(response.data.RegulationDt) ? null : response.data.RegulationDt.split(' ')[0];
                // 規定履歴PK
                this.RegulationHistPk = response.data.RegulationHistPk;
                // 規定名称
                this.RegulationNm = response.data.RegulationNm;
                // 規定内容
                this.RegulationContent = response.data.RegulationContent;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存する。
        storage: sessionStorage,
    },
});
